export default __webpack_public_path__ + "static/media/upcoming.53045ef1.png";